import CheckIcon from "@mui/icons-material/Check";
import styles from "./m3.module.css";

/**
 * M3 segmented button (single select). Use for tabs, view switches and short option sets.
 *
 * @param {Array} options - { value, label, icon?, count?, disabled?, tooltip? }
 * @param {*} value - selected value
 * @param {function} onChange - receives the new value
 * @param {boolean} block - stretch to the full container width
 * @param {boolean} showCheck - show a check icon on the selected segment (M3 default)
 * @param {"md"|"sm"} size - "sm" is 32px tall, for toolbars inside cards
 */
const SegmentedButton = ({ options = [], value, onChange, block = false, showCheck = true, size = "md", ariaLabel }) => (
  <div className={`${styles.seg} ${block ? styles.segBlock : ""} ${size === "sm" ? styles.segSm : ""}`} role="tablist" aria-label={ariaLabel}>
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={String(opt.value)}
          type="button"
          role="tab"
          aria-selected={active}
          disabled={opt.disabled}
          title={opt.tooltip}
          className={`${styles.segItem} ${active ? styles.segItemActive : ""}`}
          onClick={() => !active && onChange(opt.value)}
        >
          {opt.icon ? opt.icon : (active && showCheck ? <CheckIcon /> : null)}
          <span>{opt.label}</span>
          {opt.count != null && <span className={styles.segCount}>{opt.count}</span>}
        </button>
      );
    })}
  </div>
);

export default SegmentedButton;
